import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useContext, useMemo } from 'react';
import { Box } from '../../Box/Box';
import { Typography } from '../../Typography/Typography';
import { TabsContext } from '../Tabs.context';
import { createPortal } from 'react-dom';
import { Icon } from '../../Icon/Icon';
import { useIsComponentRendered } from '../../../hooks';
export const Tab = ({ label, value, children, icon, testId }) => {
    const { contentId, onChange, value: currentValue } = useContext(TabsContext);
    const isContentRendered = useIsComponentRendered(contentId);
    const selected = useMemo(() => {
        return value == currentValue;
    }, [currentValue, value]);
    const onClick = useCallback(() => {
        onChange(value);
    }, [onChange, value]);
    const color = useMemo(() => (selected ? 'neutral-900' : 'neutral-500'), [selected]);
    const content = useMemo(() => {
        const container = document.getElementById(contentId);
        if (!isContentRendered || !container || !children || !selected)
            return null;
        return createPortal(children, container);
    }, [contentId, children, selected, isContentRendered]);
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { style: { borderBottom: selected ? '2px solid #185ADB' : '2px solid transparent' }, "data-testid": testId, onClick: onClick, cursor: 'pointer', display: 'flex', gap: 'xxs', alignItems: 'center', py: 'md', children: [icon && _jsx(Icon, { color: color, name: icon, size: 'sm' }), _jsx(Typography.Text, { whiteSpace: 'nowrap', color: color, children: label })] }), content] }));
};
